import React from 'react';

import InfoHeader from '../../../sharedModules/layout/InfoHeader';

import { BackflowJobGroup } from '../../model';

interface BackflowJobGroupInfoHeaderProps {
  backflowJobGroup?: BackflowJobGroup;
}

const infoLabels = {
  order_no: 'Order No',
  company_name: 'Company',
  address: 'Address',
  water_authority_name: 'Water Authority',
  request: 'Request',
};

const BackflowJobGroupInfoHeader: React.FC<BackflowJobGroupInfoHeaderProps> = (props) => {
  const { backflowJobGroup } = props;

  return <InfoHeader record={backflowJobGroup} infoLabels={infoLabels} />;
};

export default BackflowJobGroupInfoHeader;
